<div [ngClass]="{'hide-top': (isMobile() && (scrollDirection$ | async) == scrollDown)}" class="dashboard-title">
  <div class="col-xs-12">
    <span>{{title$ | async}}<span *ngIf="(isInDashboardsMode | async)"
                                  class="title-ref">{{ref$ | async}}</span></span>
    <span class="title-toolbar" title="Add Widgets"
          *ngIf="displayWidgetGalleryButton() | async"><a [ngClass]="{'active' : (isWidgetGalleryOpen$ | async)}"
                                                          (click)="toggleWidgetSelector()"
                                                          class="btn"><span class="fa fa-th fa-lg"></span></a></span>
  </div>
</div>
